import { CSSProperties, FC, ReactNode } from 'react';
import styles from './index.module.less';
import cs from 'classnames';

interface DescriptionProps {
  label?: ReactNode;
  children?: ReactNode;
  direction?: 'vertical' | 'horizontal';
  colon?: boolean
  wrapperStyle?: CSSProperties;
  border?: boolean;
  fixedLable?: boolean;
  split?: boolean;
  contentCenter?: boolean;
}

const Description: FC<DescriptionProps> = ({ label, fixedLable, children, direction = 'horizontal', border = false, colon = true, wrapperStyle, split = true, contentCenter = false }) => {
  return (
    <div className={styles[`description-wrapper`]} style={{ fontSize: '16px', ...wrapperStyle }}>
      <div className={cs(styles['description'], styles[`description-${direction}`], { [styles[`description-${direction}-split`]]: split })}>
        <span className={cs(styles[`description-label`], {
          [styles['border-label']]: border || fixedLable,
          [styles['content-center']]: contentCenter
        })}>
          {label}
          {(direction === 'horizontal' && colon === true) && '：'}
        </span>
        <div className={cs(styles[`description-content`], {
          [styles['border-content']]: border,
        })}>
          {children || '-'}
        </div>
      </div>
    </div>
  );
};

export default Description;
